<template>
  <div>
    <app-navbar v-on:toggleDrawer="toggleDrawer"/>
    <v-navigation-drawer width="350px" v-model="drawer" absolute temporary>
      <sidebar />
    </v-navigation-drawer>
    <v-row class="main">
      <v-col class="sidebar-col hidden-sm-and-down" md="3" sm="0">
        <sidebar class="hidden-sm-and-down" />
      </v-col>
      <v-col md="7" sm="12" class="default-slot" > 
        <slot />
      </v-col>
      <v-col md="2" sm="0" class="right-sidebar hidden-sm-and-down">
          <link-summary
            class="hidden-sm-and-down"
            title="Important Links"
            v-bind:items="[
              { text: 'Aussie Times', link: '/aussietimes' },
            ]"
          />   
          <v-alert class="mb-2 mt-1"  type="warning" outlined
            v-if="!!contactInfo && (!(!!contactInfo.phoneNumber || !!contactInfo.email) || !(contactInfo.phoneNumberVerified || contactInfo.emailVerified))">
            You have not verified any form of contact. <br/> Please, go to "My Information > Profile" to verify your email address and/or mobile phone number to ensure you receive important notifications.      
          </v-alert>
          <v-alert class="mb-2 mt-1"  type="warning" outlined
            v-if="!!userInfo && !userInfo.hasNeverBeenMember && !userInfo.isActiveMember">
            <p><strong>Expired membership</strong></p>
            <p>Renew membership and stay part of the ASCA family!</p>                
            <v-btn color="secondary" @click="onRenewMembership">RENEW NOW</v-btn>
          </v-alert>
          <v-alert class="mb-2 mt-1"  type="warning" outlined
            v-if="!!userInfo && userInfo.hasNeverBeenMember">
            <p><strong>No membership</strong></p>
            <p>Gain membership and become a part of the ASCA family!</p>                
            <v-btn color="secondary" @click="onGainMembership">JOIN NOW</v-btn>
          </v-alert>
          
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Sidebar from './Sidebar.vue';
import LinkSummary from './LinkSummary.vue';
import UserFeed from './UserFeed.vue';
import AppNavbar from './AppNavbar.vue';
import { UserInfo } from "@/types/User";

import { ContactInfo } from "@/types/portal/Person";
import personService from "@/services/portal/personService";

export default Vue.extend({
  name: 'Home',
  data () {
    return {
      drawer: false,
      contactInfo: null as ContactInfo | null,
    }
  },
  props: {
    searchText: String,
  },
  components: {
    Sidebar,
    LinkSummary,
    UserFeed,
    AppNavbar,
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    }
  },
  created: function () {
    this.loadUserContactInfo();
  },
  watch: {
    userInfo: function (newVal, oldVal) {
      if (newVal === oldVal) return;

      this.loadUserContactInfo();
    },
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    },
    loadUserContactInfo: function () {
      if(!!this.userInfo){
        personService
          .getContactInformation(this.userInfo.personId)
          .then((res) => {
            if (res.found) {
              this.contactInfo = Object.assign({}, res.data);
          }}).catch(this.$handleError);
      }
    },
    onRenewMembership() {
      this.$router.push('/renew/member');
    },
    onGainMembership() {
      this.$router.push('/gain-membership');
    }
  }
});

</script>
